import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Layout, Table, Form, Select, Typography, Popconfirm, Divider, notification } from 'antd';
import AppHeader from '../../components/appHeader/AppHeader';
import { useNavigate } from 'react-router-dom';
import '../adminStoreConfig/adminStoreConfig.scss';
import '../../styles/responsive.scss';
import '../../styles/table-responsive.scss';

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            // Ensure the required rule is correctly set based on your requirements
            rules={[{ required: true, message: `Please select ${title}!` }]}
          >
            <Select style={{ width: 160 }}>
              <Select.Option value="0">Pay at Counter</Select.Option>
              <Select.Option value="1">Pay First (Stripe)</Select.Option>
              <Select.Option value="2">Pay First (Counter)</Select.Option>
            </Select>
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  

const AdminTableSetup = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [tableData, setTableData] = useState([]);
  const [storeId, setStoreId] = useState();
  const [cusId, setCusId] = useState('');
  const [cusEmail, setCusEmail] = useState('');


  const navigate = useNavigate();
const fethcTableList = async () => {
    try{
        let token = sessionStorage.getItem('jwtToken'); // 从 sessionStorage 获取 JWT Token
        if (!token) {
            token = localStorage.getItem('jwtToken'); // 从 localStorage 获取 JWT Token
        }
        const config = {
            headers: {
            authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/fetchTableList`, config);
        console.log(response);
        if (response.status === 200) {
            setTableData(response.data.results);
            setCusEmail(response.data.storeInformation.adminEmail);
            setCusId(response.data.storeInformation.adminId);
        }
        else {
            navigate('/qr_order/adminLogin');
        }
        }
        catch(error){
            navigate('/qr_order/adminLogin');
        }
    }
    
    useEffect(() => {
        fethcTableList();
    }, []);
    

  const isEditing = (record) => record.TableId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      PaymentMethod: record.PaymentMethod.toString(), // Ensure this is a string as Select values are strings
    });
    setEditingKey(record.TableId);
  };
  

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
        const row = await form.validateFields();
      //send the updated data to the server
        const token = sessionStorage.getItem('jwtToken');
        const config = {
            headers: {
            authorization: `Bearer ${token}`,
            },
        };
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/updateTableList`, {
            TableId: key,
            PaymentMethod: row.PaymentMethod,
        }, config);
        if (response.status === 200) {
            notification.success({
                message: 'Success',
                description: 'Table data has been updated'
            });

            setEditingKey('');
            fethcTableList();
        }
        else {
            notification.error({
                message: 'Error',
                description: 'Failed to update the table data'
            });
            
           

      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
      
    }
  };

  const columns = [
    {
      title: 'Table No.',
      dataIndex: 'TableNo',
      width: '25%',
    },
    {
      title: 'Payment Method',
      dataIndex: 'PaymentMethod',
      width: '25%',
      editable: true,
      render: (_, record) =>
        ({ 0: 'Pay at Counter', 1: 'Pay First (Stripe)', 2: 'Pay First (Counter)' })[record.PaymentMethod] || 'Unknown',
    },
    {
      title: 'Operation',
      dataIndex: 'Operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>

            <Popconfirm title="Are you sure to save?" onConfirm={() => save(record.TableId)} >
                    <a style={{ color: '#1677ff' }}>Save</a>
                    </Popconfirm>
      
            <Typography.Link
                      onClick={() => cancel(record.key)}
                      style={{ color: 'black', marginLeft: '8px'}}
                    >
                      Cancel
                    </Typography.Link>
          </span>
        ) : (
          <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
            Edit
          </Typography.Link>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'PaymentMethod' ? 'select' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });



  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}> 
        <AppHeader email={cusEmail} cusId={cusId} />
        <div className='table_list'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <h2>Table Set Up</h2>
            </div>
            <div className='admin_store_config'>
                <Divider orientation="left" orientationMargin="0">
                    Payment Method Setup
                </Divider>
                <Form form={form} component={false}>
                  <Table
                    components={{
                      body: {
                        cell: EditableCell,
                      },
                    }}
                    bordered
                    dataSource={tableData}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    rowKey="TableId"
                  />
                </Form>
            </div>
        </div>
    </Layout>
  );
};

export default AdminTableSetup;
